import { render } from "./AlarmRequestPermissionEditorCmp.vue?vue&type=template&id=5f8324f8"
import script from "./AlarmRequestPermissionEditorCmp.vue?vue&type=script&lang=js"
export * from "./AlarmRequestPermissionEditorCmp.vue?vue&type=script&lang=js"

import "./AlarmRequestPermissionEditorCmp.vue?vue&type=style&index=0&id=5f8324f8&lang=scss"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__